import { setSelectedLanguage } from 'utils/actions/selected-language/selected-language.actions';
import template from './rw-multilanguage-page.html';

const mapStateToThis = ({ session, config }) => {
  const { locale } = session;
  const { locales } = config;

  return {
    locale,
    locales,
  };
};
const mapDispatchToThis = {
  setSelectedLanguage,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', 'Responsive')
class RwMultiLanguagePageController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.setSelectedLanguage(this.locale);
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default class RwMultiLanguagePageComponent {
  constructor() {
    this.transclude = {
      header: '?header',
      page: '?page',
      footer: '?footer',
    };
    this.controller = RwMultiLanguagePageController;
    this.template = template;
    this.bindings = {
      form: '<',
      onLanguageSelect: '&',
      isLanguageSelectAvailable: '@?',
      hideHeader: '@?',
      hideFooter: '@?',
      pageClasses: '@?',
      headerClasses: '@?',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/multilanguage/components/rw-multilanguage-page/rw-multilanguage-page-component.js